import React, { useCallback, useMemo, useRef } from 'react';
import HtmlEditor, {
  Toolbar,
  MediaResizing,
} from 'devextreme-react/html-editor';
import { MarsApiConfig as apiConfig } from '../../../../api/mars-api-config';
import { MarsApiService as api } from '../../../../api/mars-api-service';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import toast from '../../../../utils/toast';
import { useTranslation } from 'react-i18next';
import Validator, { RequiredRule } from 'devextreme-react/validator';

export default function RFIHtmlEditor(props: {
  content: any;
  setContent: any;
  entities: any;
  setIsChanged: any;
  vetRequestId?: any;
  macros?: any;
  showEditor?: any;
  shipDetails?: any;
  isNotValid?: any;
}) {
  const {
    content,
    setContent,
    entities,
    setIsChanged,
    vetRequestId,
    macros,
    showEditor,
    shipDetails,
    isNotValid,
  } = props;
  const htmlEditor: any = useRef();
  const sizeValues = ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'];
  const fontValues = [
    'Arial',
    'Courier New',
    'Georgia',
    'Impact',
    'Lucida Console',
    'Tahoma',
    'Times New Roman',
    'Verdana',
  ];
  const { t } = useTranslation();

  const dataSource = (entityId: any) => {
    return new DataSource({
      store: new CustomStore({
        key: 'employeeId',
        loadMode: 'raw',
        load: () => {
          return api.get({
            url: apiConfig.attributesByEnventId + entityId,
            params: { isRequiredForRFITemplate: true },
          });
        },
      }),
    });
  };

  const itemsList = useMemo(() => {
    const list: any[] = [
      {
        name: 'font',
        acceptedValues: fontValues,
        cssClass: 'app-l-font-class',
        options: {
          dropDownOptions: {
            resizeEnabled: true,
            width: '200px',
          },
        },
      },
      { name: 'separator' },
      { name: 'bold' },
      { name: 'italic' },
      { name: 'underline' },
      { name: 'background' },
      { name: 'separator' },
      {
        name: 'size',
        acceptedValues: sizeValues,
        cssClass: 'app-l-font-size-class',
      },
      { name: 'separator' },
      { name: 'alignLeft' },
      { name: 'alignCenter' },
      { name: 'alignRight' },
      { name: 'separator' },
      { name: 'orderedList' },
      { name: 'bulletList' },
      { name: 'increaseIndent' },
      { name: 'decreaseIndent' },
      { name: 'separator' },
      { name: 'insertTable' },
    ];
    entities.map((entity: any) => {
      const item = {
        name: entity.displayName,
        widget: 'dxSelectBox',
        options: {
          dataSource: dataSource(entity.masterEntityId),
          valueExpr: 'attributeName',
          displayExpr: 'displayName',
          onValueChanged: (e: any) => insertText(e, entity.entityName),
          placeholder: entity.displayName,
          searchEnabled: true,
          dropDownOptions: {
            resizeEnabled: true,
            width: '300px',
          },
        },
        cssClass: 'app-l-filter-dropdown',
      };
      list.push(item);
    });
    return list;
  }, [entities]);

  const insertText = useCallback((data: any, entityName: any) => {
    const selection = htmlEditor?.current?.instance?.getSelection(true);
    let text = '';
    if (vetRequestId && data.value && entityName) {
      text = insertValues(data.value, entityName);
    } else {
      text = '@' + entityName + '.' + String(data.value);
    }
    if (!text) {
      toast.warning({
        title: 'Warning',
        message: t('toast.NoDataAvailable'),
      });
    }
    data.value &&
      htmlEditor?.current?.instance?.insertText(selection.index, String(text));
  }, []);
  const insertValues = useCallback((attribute: string, entityName: string) => {
    let value = '';
    if (entityName === 'Ship') {
      value = shipDetails[attribute] ? shipDetails[attribute] : '';
    } else {
      const entity = macros[entityName];
      value = entity && entity[attribute] ? entity[attribute] : '';
    }
    return value;
  }, []);

  return (
    <>
      {showEditor && (
        <HtmlEditor
          height="100%"
          defaultValue={content}
          valueType="html"
          onValueChanged={(e) => {
            setContent(e.value);
            setIsChanged(true);
          }}
          ref={htmlEditor}
          className={
            isNotValid
              ? 'm-c-text-editor m-c-mail-text-editor m-c-text-editor-error-border'
              : 'm-c-text-editor m-c-mail-text-editor'
          }
          validationMessageMode="always"
        >
          <MediaResizing enabled={true} />
          <Toolbar multiline={false} items={itemsList} />

          {/* {vetRequestId && (
            <Validator>
              <RequiredRule message={t('errors.mailContentRequired')} />
            </Validator>
          )} */}
        </HtmlEditor>
      )}
      {isNotValid && (
        <div className="m-c-text-editor-error-text">
          {t('errors.mailContentRequired')}
        </div>
      )}
    </>
  );
}
